import styled from 'styled-components/macro';
import { Box, Flex, Button } from 'components/ui';
import { useWindowSize } from 'hooks/useWindowSize';
import { Link } from 'react-router-dom';
import FuturaIcon from 'img/futura-icon.svg';
import { remixEnabled } from 'utils/config';
import futuraPreview1 from 'img/futura-preview-1.png';
import futuraPreview2 from 'img/futura-preview-2.png';
import futuraPreview3 from 'img/futura-preview-3.png';
import Preview from 'components/ui/Preview';
import SectionWrapper from 'components/ui/SectionWrapper';
import SectionTitle from 'components/ui/SectionTitle';

const Wrapper = styled(Box)`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid white;

  video {
    position: absolute;
    top: 0;
    bottom: 0;
  }
`;

const Headline = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, black, rgba(0, 0, 0, 0.25));
  z-index: 2;

  h1 {
    text-align: left;
  }

  a {
    text-decoration: none;
  }
`;

const LegacyFuturaSection = () => {
  const ws = useWindowSize();
  const isWide = ws.width / ws.height >= 1.11;
  const futuraBg = ws.width <= 480 ? 'futura-bg-small.mp4' : 'futura-bg.mp4';

  return (
    <Wrapper height={['680px', '510px', '510px']}>
      <Headline p={['40px 16px', '40px']}>
        <img alt="futura" src={FuturaIcon} style={{ margin: '32px 0' }} />
        <h1>Futura is here!</h1>
        <Box mt={2} mb={4} width="100%" maxWidth="440px">
          FUTURA is the next evolution of EulerBeats. It pushes the boundaries of generative music
          and art by placing artists and token owners at the heart of the experience.
        </Box>
        <Box mb={4}>Listen to and view your Futura Mix NFTs today.</Box>
        <Flex flexDirection={['column', 'row']}>
          <Link to="/futura/gallery">
            <Button mb={2} color="white" bg="black" border="1px solid white">
              Explore Futura
            </Button>
          </Link>
        </Flex>
      </Headline>
      <video
        autoPlay
        muted
        loop
        id="bgVideo"
        width={isWide ? '100%' : 'auto'}
        height={isWide ? 'auto' : '100%'}
      >
        <source src={futuraBg} type="video/mp4" />
      </video>
    </Wrapper>
  );
};

const FuturaSection = () => {
  if (!remixEnabled) {
    return <LegacyFuturaSection />;
  }

  return (
    <SectionWrapper height="380px" background="linear-gradient(90deg, black, rgba(0, 0, 0, 0.25))">
      <Box
        p={['40px 16px', '40px']}
        height="100%"
        zIndex={2}
        width={['100%', 'auto']}
        flexGrow={1}
        flexShrink={0}
      >
        <SectionTitle fontWeight={700} fontSize="32px">
          Futura
        </SectionTitle>
        <Box
          mt={2}
          mb={4}
          width="100%"
          maxWidth="440px"
          fontSize="16px"
          lineHeight={1.375}
          fontWeight={400}
        >
          FUTURA is the next evolution of EulerBeats. It pushes the boundaries of generative music
          and art by placing artists and token owners at the heart of the experience.
        </Box>
        <Box
          mb={4}
          width="100%"
          maxWidth="440px"
          fontSize="16px"
          lineHeight={1.375}
          fontWeight={400}
        >
          Listen to and view your Futura Mix NFTs today.
        </Box>
        <Flex flexDirection={['column', 'row']}>
          <Link to="/futura/gallery">
            <Button mb={2} color="white" bg="black" disabled={!remixEnabled} outlined>
              Explore Futura
            </Button>
          </Link>
        </Flex>
      </Box>

      <Box
        height="100%"
        display={['none', 'flex']}
        flexWrap="nowrap"
        width="50%"
        justifyContent="flex-end"
      >
        <Preview image={futuraPreview1} height="100%" flexGrow={1} maxWidth="300px" />
        <Preview image={futuraPreview2} height="100%" flexGrow={1} maxWidth="300px" />
        <Preview image={futuraPreview3} height="100%" flexGrow={1} maxWidth="300px" />
      </Box>
    </SectionWrapper>
  );
};

export default FuturaSection;
